import Fab from '@mui/material/Fab';
import SvgIcon from '@mui/material/SvgIcon';
import Tooltip from '@mui/material/Tooltip';
import FabContactIcon from '@assets/icons/fabContactIcon.svg?component';
import type { ContactFabProps } from './ContactFab.types';

const ContactFab = ({
  onClick,
  disabled,
  ariaLabel = 'Contact us',
  tooltipTitle = 'Contact Us',
  icon = <SvgIcon component={FabContactIcon} inheritViewBox fontSize="inherit" color="inherit" />,
  bottomOffsetPx,
}: ContactFabProps) => {
  const sx = bottomOffsetPx === undefined ? undefined : { bottom: `${bottomOffsetPx}px` };

  const fab = (
    <Fab variant="contact" aria-label={ariaLabel} onClick={onClick} disabled={disabled} sx={sx}>
      {icon}
    </Fab>
  );

  return (
    <Tooltip placement="top" arrow title={tooltipTitle}>
      {disabled ? <span>{fab}</span> : fab}
    </Tooltip>
  );
};

export default ContactFab;
